// extracted by mini-css-extract-plugin
export default {"wrap":"InfoHorizentalMode_wrap__sUWyG","text":"InfoHorizentalMode_text__1dUFI"};